// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"23a0da3b","472":"a09fb367"}[chunkId] + ".chunk.js";
};